import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import useUser from "@/hooks/useUser"
import { useInfiniteQuery } from "@tanstack/react-query"
import { Link } from "react-router"
import { curation, INDEX_PATH } from "./api"
import { CurationBadge } from "./CurationPanel"

export function ReviewQueue() {
  const { user } = useUser()
  const { translate: t } = useTranslation()
  const query = useInfiniteQuery({
    queryKey: ["company-index", user?.organization, "attention"],
    queryFn: ({ pageParam }) => curation.attention(undefined, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    enabled: !!user?.organization,
    refetchInterval: 30000,
  })
  const items = query.data?.pages.flatMap((page) => page.items) ?? []
  return (
    <section className="space-y-3" aria-label={t("CI_REVIEW_QUEUE")}>
      <p className="text-sm text-muted-foreground">
        {t("CI_REVIEW_QUEUE_HINT")}
      </p>
      {query.isPending && <p>{t("CI_LOADING")}</p>}
      {query.isError && (
        <p role="alert">
          {t("CI_ERROR")}{" "}
          <Button onClick={() => void query.refetch()}>{t("CI_RETRY")}</Button>
        </p>
      )}
      {query.isSuccess && !items.length && <p>{t("CI_QUEUE_EMPTY")}</p>}
      {items.map((doc) => (
        <Link
          key={doc.id}
          to={`${INDEX_PATH}/${doc.companyId}?document=${doc.id}`}
          className="flex items-center justify-between gap-4 rounded-lg border p-4 hover:border-primary"
        >
          <span className="break-all">{doc.filename}</span>
          <CurationBadge document={doc} />
        </Link>
      ))}
      {query.hasNextPage && (
        <Button
          disabled={query.isFetchingNextPage}
          onClick={() => void query.fetchNextPage()}
        >
          {t("CI_MORE")}
        </Button>
      )}
    </section>
  )
}
